import {createSvgIcon} from '../create-svg-icon';

export const VerticalAlignBottomIcon = createSvgIcon(
  <path d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z" />
, 'VerticalAlignBottomOutlined');
